export default __webpack_public_path__ + "static/media/chevron.6de1be48.svg";